import React from 'react';

import styles from '../../styles/Contact.module.scss';

const ContactWork = () => {
  return (
    <div className={styles.workWrapper}>
      <div className={styles.container}>
        <div className={styles.insideContainer}>
          <p className={styles.contactHeader}>Kontakt</p>
          <p className={styles.email}>praca@toya.com.pl</p>
        </div>
        <div className={`${styles.row} ${styles.workRow}`}>
          <div className={styles.insideContainer}>
            <p className={styles.insideText}>
              <span>Administratorem danych osobowych (ADO)</span> jest Telewizja
              TOYA Sp. z o.o. z&nbsp;siedzibą w&nbsp;Łodzi przy ulicy Łąkowej
              29B.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactWork;
